const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_RULES)
const activityGroupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_ACTIVITIES)

export const apiLoyaltyRules = {
	fetchLoyaltyRulesTypes: async (): Promise<IPointLoyaltyRulesTypeModel[]> => {
		const { data } = await apiCommon<IPointLoyaltyRulesType[]>(`${groupPrefix}/types`, { method: 'GET' })

		return data.map(d => PointLoyaltyRuleType(d))
	},
	assignLoyaltyRuleToActivity: async (
		id: number,
		payload: IPointLoyaltyRulesCreatePayload,
	): Promise<IPointLoyaltyRulesModel> => {
		const { data } = await apiCommon<IPointLoyaltyRules>(`${activityGroupPrefix}/${id}/loyalty-rules`, {
			method: 'POST',
			body: payload,
		})

		return PointsLoyaltyRule(data)
	},
	updateLoyaltyActivityRule: async (payload: IPointLoyaltyRulesUpdatePayload): Promise<IPointLoyaltyRulesModel> => {
		const { data } = await apiCommon<IPointLoyaltyRules>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return PointsLoyaltyRule(data)
	},
}
